import React from 'react';
import ScrollReveal from './ScrollReveal';

/**
 * Wraps each child in alternating left/right scroll reveals.
 */
const ScrollRevealStack = ({
  children,
  className = '',
  startDirection = 'left',
  staggerMs = 150,
}) => {
  const items = React.Children.toArray(children).filter(Boolean);

  return (
    <div className={className}>
      {items.map((child, index) => {
        const fromLeft = startDirection === 'left' ? index % 2 === 0 : index % 2 !== 0;
        return (
          <ScrollReveal
            key={child.key ?? `reveal-${index}`}
            direction={fromLeft ? 'left' : 'right'}
            delayMs={index * staggerMs}
          >
            {child}
          </ScrollReveal>
        );
      })}
    </div>
  );
};

export default ScrollRevealStack;
